import { Button, Card, Col, Form, InputGroup } from 'react-bootstrap';
import './BeAnOwnerFormStepper.scss';
import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import PhoneInputControlled from '../../../atoms/PhoneInputControlled/PhoneInputControlled';
import { setShowSignInUp } from '../../../../redux/user/user.actions';
import { connect } from 'react-redux';
import { CountryInfo } from '../../../../redux/countryInfo/countryInfo';
import { UrbainUser } from '../../../../redux/user/user.types';
import usePost from '../../../../services/usePost';
import { isEmpty } from '../../../../utils/utils';

export interface StepProps {
  handleSubmit?: Function;
  setShowSignInUp: Function;
  nextStep: Function;
  countryInfo: CountryInfo;
  urbainUser: UrbainUser;
}

function Step02({ handleSubmit, setShowSignInUp, countryInfo, urbainUser, nextStep }: StepProps) {
  const {
    register,
    control,
    setValue,
    watch,
    formState: { errors }
  } = useFormContext();
  const formData = watch();

  const [submitFormResult, submitForm, isLoading, error] = usePost<any>({
    url: '/beanowner',
    defaultValue: {},
    successMessage: ''
  });

  useEffect(() => {
    if (!isEmpty(submitFormResult) && isEmpty(error)) {
      nextStep(3);
    }
  }, [submitFormResult]);

  return (
    <Card className={'card-stepper'}>
      <Card.Body>
        <Card.Subtitle className="mb-1 text-muted">Step 2 of 3</Card.Subtitle>
        <Card.Title>One Last Step!</Card.Title>
        {/*<Card.Text>
          Already have an account? <a onClick={() => setShowSignInUp()}>Log In</a>
        </Card.Text>*/}
        <Form.Row>
          <Form.Group as={Col} controlId="formGridName">
            <Form.Label className="form-label-info required">First Name</Form.Label>
            <Form.Control
              {...register('FirstName', {
                required: 'First name is required.'
              })}
            />
            {errors.FirstName && (
              <Form.Control.Feedback type="invalid" className="display-block">
                {errors.FirstName.message || 'Error'}
              </Form.Control.Feedback>
            )}
          </Form.Group>
          <Form.Group as={Col} controlId="formGridLastName">
            <Form.Label className="form-label-info required">Last Name </Form.Label>
            <Form.Control
              {...register('LastName', {
                required: 'Last name is required.'
              })}
            />
            {errors.LastName && (
              <Form.Control.Feedback type="invalid" className="display-block">
                {errors.LastName.message || 'Error'}
              </Form.Control.Feedback>
            )}
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group xs={12} as={Col} controlId="formPhoneNumber">
            <Form.Label className="form-label-info required">Primary Phone Number </Form.Label>
            <InputGroup className="mb-2 phone-input">
              <PhoneInputControlled
                control={control}
                required={'Phone Required.'}
                name={'PhoneNumber'}
                defaultValue={urbainUser?.PhoneNumber}
                defaultCountry={countryInfo?.country_code?.toLowerCase()}
                handleChangeCountry={(countryCode: string) => setValue('PhoneNumberCode', countryCode)}
              />
            </InputGroup>
          </Form.Group>
        </Form.Row>
        <Form.Row>
          <Form.Group as={Col} controlId="formGridEmail" xs={12}>
            <Form.Label className="form-label-info required">Email Address</Form.Label>
            <InputGroup className="mb-2">
              <Form.Control
                className="email-input"
                type="email"
                placeholder="Enter email"
                {...register('Email', {
                  required: 'Email address is required.',
                  pattern: {
                    value: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/,
                    message: 'Email not valid.'
                  }
                })}
              />
              {errors.Email && (
                <Form.Control.Feedback type="invalid" className="display-block">
                  {errors.Email.message || 'Error'}
                </Form.Control.Feedback>
              )}
            </InputGroup>
          </Form.Group>
        </Form.Row>
        {/*<Form.Row>
          <Form.Group as={Col} controlId="formPassword">
            <Form.Label>Password</Form.Label>
            <Form.Control type="password" placeholder="Password" {...register('password')} required />
          </Form.Group>
        </Form.Row>*/}
      </Card.Body>
      <Card.Footer>
        <Button
          className={'next-button mt-2'}
          disabled={!formData.Email}
          onClick={() => {
            submitForm(formData);
          }}
        >
          Finish
        </Button>
      </Card.Footer>
    </Card>
  );
}

const mapDispatchToProps = {
  setShowSignInUp
};

const mapStateToProps = (state: any) => ({
  countryInfo: state.countryInfo,
  urbainUser: state.user.urbainUser
});

export default connect(mapStateToProps, mapDispatchToProps)(Step02);
